<template>
  <div class="legal-assistant-container">
    <iframe
      :src="`${publicPath}legal-assistant.html`"
      class="legal-assistant-frame"
      allow="microphone *; clipboard-read; clipboard-write; speech-recognition;"
      title="EJSC Legal Assistant"
    ></iframe>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EjscLegalAssistant",
  data() {
    return {
      publicPath: process.env.BASE_URL || "/",
      scrollHandler: null,
      messageHandler: null,
      viewportHandler: null,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.classList.add("legal-assistant-locked");
    document.documentElement.classList.add("legal-assistant-locked");

    this.scrollHandler = () => {
      if (window.scrollY !== 0 || window.scrollX !== 0) {
        window.scrollTo(0, 0);
      }
    };
    window.addEventListener("scroll", this.scrollHandler);

    if (window.visualViewport) {
      this.viewportHandler = () => {
        const h = window.visualViewport.height;
        const container = this.$el;
        if (container) {
          container.style.height = `${h}px`;
        }
      };
      window.visualViewport.addEventListener("resize", this.viewportHandler);
    }

    const sendUserData = () => {
      try {
        const iframe = this.$el.querySelector("iframe");
        if (iframe && iframe.contentWindow) {
          let u = this.$store.getters.getUser;
          let uid = u ? (u.id || u.user_id || u.email) : null;
          let firstname = u ? u.firstname : null;
          let imageUrl = u ? u.image_url : null;
          let email = u ? u.email : null;

          if (!uid) {
            try {
              const cached = JSON.parse(localStorage.getItem("user_profile") || "null");
              if (cached) {
                uid = cached.id || cached.user_id || cached.email;
                firstname = firstname || cached.firstname;
                imageUrl = imageUrl || cached.image_url;
                email = email || cached.email;
              }
            } catch (e) {}
          }

          if (uid || firstname) {
            iframe.contentWindow.postMessage({
              type: "USER_DATA",
              user_id: uid,
              id: uid,
              email: email,
              firstname: firstname,
              image_url: imageUrl,
            }, "*");
          }

          const token = localStorage.getItem("user_token");
          const sig = localStorage.getItem("web_token");
          if (token && (!uid || !firstname)) {
            axios.get("https://api.ejsconline.com:442/api/v_1/auth/profile", {
              headers: {
                Authorization: token,
                Signature: sig,
              },
            }).then((res) => {
              const data = res.data && res.data.success && res.data.success.data;
              if (data) {
                try {
                  this.$store.commit("MakeUser", data);
                } catch (e) {}
                try {
                  localStorage.setItem("user_profile", JSON.stringify(data));
                } catch (e) {}
                const resolvedUid = data.id || data.user_id || data.email;
                iframe.contentWindow.postMessage({
                  type: "USER_DATA",
                  user_id: resolvedUid,
                  id: resolvedUid,
                  email: data.email,
                  firstname: data.firstname,
                  image_url: data.image_url,
                }, "*");
              }
            }).catch(() => {});
          }
        }
      } catch (e) {}
    };

    this.messageHandler = (event) => {
      if (event && event.data) {
        if (event.data.type === "INPUT_FOCUSED") {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        } else if (event.data.type === "NAVIGATE_TO") {
          if (event.data.path) {
            this.$router.push(event.data.path).catch(() => {});
          }
        } else if (event.data.type === "SIGN_OUT") {
          this.$store.dispatch("LogOut");
          this.$router.push("/login").catch(() => {});
        } else if (event.data.type === "REQUEST_USER_DATA") {
          sendUserData();
        }
      }
    };
    window.addEventListener("message", this.messageHandler);

    sendUserData();
    setTimeout(sendUserData, 300);
    setTimeout(sendUserData, 1000);
    setTimeout(sendUserData, 2500);
  },
  beforeDestroy() {
    document.body.classList.remove("legal-assistant-locked");
    document.documentElement.classList.remove("legal-assistant-locked");
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
    if (this.viewportHandler && window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.viewportHandler);
    }
    if (this.messageHandler) {
      window.removeEventListener("message", this.messageHandler);
    }
  },
};
</script>

<style scoped>
.legal-assistant-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  width: 100dvw;
  height: 100vh;
  height: 100dvh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  z-index: 40;
  background-color: #F5F5FD;
}

@media screen and (min-width: 1000px) {
  .legal-assistant-container {
    left: 290px;
    width: calc(100vw - 290px);
    width: calc(100dvw - 290px);
  }
}

.legal-assistant-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>

<style>
html.legal-assistant-locked,
body.legal-assistant-locked {
  overflow: hidden !important;
  height: 100% !important;
  height: 100dvh !important;
  position: fixed !important;
  width: 100% !important;
  inset: 0 !important;
}
</style>
